import {useCallback} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import ChekinAPI, {GuestTokenStorageHandler} from '@guestapp/sdk';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useFetchUser} from './useFetchUser';

function useAuth() {
  const queryClient = useQueryClient();
  const {
    data: user,
    refetch,
    isLoading,
    isError,
    error,
    isInitialLoading,
  } = useFetchUser();
  const isLoggedIn = Boolean(user?.id && GuestTokenStorageHandler.hasToken());

  const logout = useCallback(() => {
    GuestTokenStorageHandler.removeToken();
    queryClient.setQueryData([QUERY_CACHE_KEYS.user], null);
    queryClient.setQueryData([QUERY_CACHE_KEYS.participants], null);
  }, [queryClient]);

  const authenticate = useCallback(
    ({token}: {token: string}) => {
      GuestTokenStorageHandler.persistToken(token);
      ChekinAPI.setJwtToken(token);
      void refetch();
    },
    [refetch],
  );

  return {
    logout,
    isLoggedIn,
    isLoading,
    isError,
    error,
    user,
    authenticate,
    isInitialLoading,
  };
}

export {useAuth};
